<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
        preserveAspectRatio="xMidYMid"
    >
        <path
            v-if="weight === 'THIN'"
            d="M8.48215 1.51786C8.48215 0.95571 8.93785 0.5 9.5 0.5C11.3789 0.5 13.2156 1.05717 14.7779 2.10104C16.3402 3.14491 17.5578 4.62861 18.2769 6.36451C18.9959 8.1004 19.184 10.0105 18.8175 11.8534C18.4509 13.6962 17.5461 15.3889 16.2175 16.7175C14.8889 18.0461 13.1962 18.9509 11.3534 19.3175C9.51054 19.684 7.60041 19.4959 5.86451 18.7769C4.12861 18.0578 2.64492 16.8402 1.60104 15.2779C0.557168 13.7157 1.74707e-06 11.8789 0 10C0 9.43786 0.455708 8.98215 1.01785 8.98215C1.58 8.98215 2.03571 9.43786 2.03571 10C2.03571 11.4763 2.47348 12.9194 3.29367 14.1469C4.11386 15.3744 5.27962 16.3311 6.64354 16.8961C8.00746 17.4611 9.50828 17.6089 10.9562 17.3209C12.4041 17.0328 13.7342 16.3219 14.7781 15.278C15.822 14.2341 16.5329 12.9041 16.8209 11.4562C17.1089 10.0083 16.9611 8.50746 16.3961 7.14354C15.8312 5.77962 14.8744 4.61386 13.6469 3.79367C12.4194 2.97349 10.9763 2.53571 9.5 2.53571C8.93785 2.53571 8.48215 2.08 8.48215 1.51786Z" 
            fill="currentColor"
            :fill-opacity="opacity"
        />
    </svg>
</template>
<script>
export default {
    name: 'check-circle-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        opacity: {
            type: [String, Number],
            default: 0.8,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>
